import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getBaseUrl } from '../../Utils';

interface runSqlQuery {
    Sql: string[];
    QueryResult: [] | null;
}

interface ItemState {
    items:  { [key: number]: any[] };
    message: string | null; 
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: ItemState = {
    items:  [],
    message: null,
    status: 'idle',
    error: null,
};

async function runSqlQueriesAPICall(newItem: string[]) {
    const response = await axios.post(`${getBaseUrl()}API/v3/RunSqlQueries/run`, {
        SqlRequest: newItem,
    })
    return response.data;
}

export const createItem = createAsyncThunk(
    'items/createItem',
    runSqlQueriesAPICall
);

const RunSqlQueriesSlice = createSlice({
    name: 'RunSqlQueries',
    initialState,
    reducers: {
        // This action will reset the state back to its initial values
        resetState:(state)=>{
            state.items=[],
            state.message=null,
            state.status='idle',
            state.error= null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createItem.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createItem.fulfilled, (state, action) => {
                    state.status = 'succeeded';
                    // FP-10629
                    const queryResult = action.payload?.data?.QueryResult;
                    if (queryResult && queryResult[0] !== undefined) {
                        state.items = queryResult;
                        state.message = null; // Clear any previous error message
                    } else {
                        state.items = [];
                        state.message = action.payload?.data?.message;
                    }
            })
            .addCase(createItem.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'Please enter valid query in the box';
            });
    },
});
export const { resetState } = RunSqlQueriesSlice.actions;
export default RunSqlQueriesSlice.reducer;

